/**
 * @typedef {import('./types').ModalTrapActivateEvent} ModalTrapActivateEvent
 * @typedef {import('./types').ModalTrapDeactivateEvent} ModalTrapDeactivateEvent
 * @typedef {import('./types').CartForm} CartForm
 */

if (!customElements.get('cart-tray')) {
  customElements.define(
    'cart-tray',
    class CartTray extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        window.addEventListener('modal-trap-activate', async (/** @type {ModalTrapActivateEvent} */ e) => {
          /** @type {CartForm | null} */
          const cart = this.querySelector('cart-form');

          if (e.detail.id === 'cart-tray' && cart) {
            cart.reloadSection();
          }
        });
      }
    },
  );
}
